<template>
    <div class="search-communicate grid xs-grid-cols-1 gap-3">
        <div class="grid xs-grid-cols-1 gap-1">
            <div>
                <span class="text-bold">{{ molang('search.filter.commute') }}</span>
            </div>
            <mvtInputGeo class="small" btnclass="" v-model="geoInfo" :placeholder="molang('search.filter.commutePlaceholder')" :key="geoInfo.text ===''" :options="{types:['address']}" />
        </div>
        <div class="grid xs-grid-cols-1 gap-1">
            <div class="text-bold">{{ molang('search.filter.expandSearchArea') }}</div>
            <mvtRadio class="small buttons flex left wrap toggle" :data="commuteData" v-model="commuteRadius" />
        </div>
    </div>
</template>
<script src="./search-communicate.js"></script>
